import React from "react";
import { Link } from "react-router-dom";
import { isIOS, isAndroid } from "../../util/navigator";
import { uploadUrl, sellUrl } from "../../util/url";
import PropTypes from "prop-types";
import { useAuthStore } from "../../store/useAuthStore";

/**
 * 네비게이션 - 판매 메뉴
 * @returns {Element}
 * @constructor
 */
const SellNavigationMenu = ({ userAgent }) => {
  const { isLogin, user } = useAuthStore();
  const isMobile = isIOS(userAgent) || isAndroid(userAgent);

  const canUpload = (() => {
    if (!isLogin || !user || !user.seller) return false;
    const { seller } = user;
    return Boolean(seller.is_certified || seller.is_tester || user.isBusiness);
  })();
  if (!isMobile && canUpload) {
    return (
      <Link
        className="Navigation-link nav-link"
        to={uploadUrl()}
      >
        판매
      </Link>
    );
  }

  return (
    <Link
      className="Navigation-link nav-link"
      to={sellUrl()}
    >
      판매
    </Link>
  );
};

SellNavigationMenu.propTypes = {
  userAgent: PropTypes.string,
};

export default SellNavigationMenu;
